import React, { useState, useEffect } from 'react';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import styles from './styles.module.css'; // Assuming style.module.css is in the same directory
import PropTypes from 'prop-types'
import { connect, useSelector } from 'react-redux'
import { AiFillDelete, AiFillEdit } from 'react-icons/ai'
import { toast, ToastContainer } from 'react-toastify';
import { Container } from 'react-bootstrap';
import { DatePicker, Collapse, Select, Button, Radio } from 'antd';
import dayjs from 'dayjs';
import { DownloadOutlined } from '@ant-design/icons';
const { Panel } = Collapse;

const Reports = ({ user, type }) => {

    const [filterFromDate, setFilterFromDate] = useState(null);
    const [filterToDate, setFilterToDate] = useState(null);
    const [activeKey, setActiveKey] = useState(null);
    const [isLoading, setIsLoading] = useState({getActiveStatesLoading:false,getActiveStatesDataReportLoading:false});
    const [statesList,setStatesList] = useState([]);
    const [selectedStates,setSelectedStates] = useState([]);
    const [selectedTimezone,setSelectedTimezone] = useState('Local Timezone')

    useEffect(() => {
        if (activeKey === '1') {

            getActiveStates();
        }
    }, [activeKey])

    const getActiveStates = async () => {
        try {

            setIsLoading((prev)=>{
                return {    ...prev, getActiveStatesLoading:true}
            });
            const result = await BreathAPIs.getActiveStates();
            const activeStatesDropDownValues = result.data.map((obj)=>{return {value:obj._id,label:obj._id}})
            setStatesList(activeStatesDropDownValues);
            setIsLoading((prev)=>{
                return {    ...prev, getActiveStatesLoading:false}
            });
        } catch (error) {
            console.log(error);
            setIsLoading((prev)=>{
                return {    ...prev, getActiveStatesLoading:false}
            });
        }
    }

    const handleCollapseChange = (key) => {
        setActiveKey(key[0]);
    };

    const toLocalISOString = (date) => {
        const pad = (num) => String(num).padStart(2, '0');
    
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1); // getMonth() is zero-based
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
        const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
    
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
    }

    const getStateLevelDataReport = async ()=>{
        try {
            setIsLoading((prev)=>{
                   return {    ...prev, getActiveStatesDataReportLoading:true}
               });


            const result = await BreathAPIs.getStateLevelDataReport(selectedTimezone==='Local Timezone'?filterFromDate:toLocalISOString(filterFromDate),selectedTimezone==='Local Timezone'?filterToDate:toLocalISOString(filterToDate),selectedStates.length>0?selectedStates:[]);

             if(result.data && result.data.length === 0){
                        toast.warn('No data to process in this time frame');
                       setIsLoading((prev)=>{
                return {    ...prev, getActiveStatesDataReportLoading:false}
            });
                        return;
                    }
                    if(result.status !== 200){
                        toast.error('Error generating csv');
                         setIsLoading((prev)=>{
                            return {    ...prev, getActiveStatesDataReportLoading:false}
                        });
                        return;
                    }

            
        const csvResponse = jsonToCsv(result.data,'stateLevelDataReport');

        // const formattedFromDate = new Date(filterFromDate).toISOString().split('T')[0].replace(/(\d{4})-(\d{2})-(\d{2})/, '$1-$3-$2');
        // const formattedToDate = new Date(filterToDate).toISOString().split('T')[0].replace(/(\d{4})-(\d{2})-(\d{2})/, '$1-$3-$2');
        const formattedFromDate = [filterFromDate.getMonth() + 1,filterFromDate.getDate(),  filterFromDate.getFullYear()].map(num => String(num).padStart(2, '0')).join('-');
        const formattedToDate = [filterToDate.getMonth() + 1,filterToDate.getDate(),  filterToDate.getFullYear()].map(num => String(num).padStart(2, '0')).join('-');
           
        // console.log('filterfromdate: ',filterFromDate);
        // console.log('formatted filter from date: ',formattedFromDate);
        // console.log('filterfromdate: ',filterToDate);
        // console.log('formatted filter from date: ',formattedToDate);
          const blob = new Blob([csvResponse], { type: 'text/csv' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.setAttribute('href', url);
          a.setAttribute('download', `${formattedFromDate}_${formattedToDate}_stateLevelDataReport.csv`);
          a.click();
          // Clean up the URL object
          URL.revokeObjectURL(url);

           setIsLoading((prev)=>{
                return {    ...prev, getActiveStatesDataReportLoading:false}
            });
            
        } catch (error) {
             setIsLoading((prev)=>{
                return {    ...prev, getActiveStatesDataReportLoading:false}
            });
            console.error('Error while generating State level Data Report',error.message)
        }
    }

    const jsonToCsv = (json,reportType) => {

       
        if(reportType === 'stateLevelDataReport'){
            

            let csvContent = "";
        
           
            csvContent += "State,StateLocations,TotalEnergyConsumption,TotalRevenue,TotalBreatheRevenue,TotalTaxCost,TotalUnutilizedFees,TotalIdleFees,TotalEnergyCost\n";
        
            json.forEach((item) => {
                // item.groupedDocuments.forEach((doc) => {
                    csvContent += `${item._id},${item.locationCount},${item.energyConsumption},${item.totalRevenue},${item.totalBreatheRevenue},${item.totalTaxCost},${item.totalUnutilizedFees},${item.totalIdleFees},${item.totalEnergyCost}\n`;
                // });
            });
        
        

            return csvContent
        }
      };

    const changeTimezone = (e)=>{
        if(e.target.value === 'UTC Timezone'){
            setSelectedTimezone('UTC Timezone');
        }
        else{
             setSelectedTimezone('Local Timezone');
        }
    }

    


    return (
        
        <Container>
            <ToastContainer></ToastContainer>
            <div>
           
                <Collapse accordion onChange={handleCollapseChange}
                >

                    <Panel key='1' header='State Level Data Report'>

                        <div className={`${styles['filters']}`} >

                            <div className={`${styles['filter-element']}`}>
                                <DatePicker
                                    size='middle'
                                    style={{ minWidth: '100%' }}
                                    value={filterFromDate ? dayjs(filterFromDate) : null}
                                    placeholder='Date From'
                                    onChange={(date) => setFilterFromDate(date ? new Date(new Date(date).setHours(0, 0, 0, 0)) : null)}
                                    // inputReadOnly={true}
                                    disabledDate={current => current.isAfter(dayjs().endOf('day')) || (filterToDate && current.isAfter(dayjs(filterToDate).endOf('day')))}
                                />
                            </div>
                            <div className={`${styles['filter-element']}`}>

                                <DatePicker
                                    size='middle'
                                    style={{ minWidth: '100%' }}
                                    value={filterToDate ? dayjs(filterToDate) : null}
                                    // inputReadOnly={true}
                                    placeholder='Date To'
                                    onChange={(date) => setFilterToDate(date ? new Date(new Date(date).setHours(23, 59, 59, 999)) : null)}
                                    disabledDate={current => current.isAfter(dayjs().endOf('day')) || (filterFromDate ? current.isBefore(dayjs(filterFromDate)) : current.isBefore((dayjs().subtract(6, 'month')).startOf('day')))}
                                />
                            </div>
                            <div className={`${styles['flex-container']}`}>
                                <div style={{width:'100%',display:'flex',flexDirection:'column'}}>
                                <div  className={`${styles['select-container']}`}>
                                    <Select
                                    
                                    showSearch
                                    allowClear
                                    loading={isLoading.getActiveStatesLoading}
                                    placeholder={'Select States'}
                                    style={{ width: '100%' }}
                                    onChange={(value) => { setSelectedStates(value) }}
                                    onClear={() => setSelectedStates([])}
                                    options={statesList}
                                    mode="multiple"
                                    size='middle'
                                    maxTagCount={3}
                                    //   value={location ? location : []}
                                    />
                                </div>
                                <div  className={`${styles['filter-element']}`}>
                                
                                    <Radio.Group
                                    block
                                    options={[
                                { label: 'Local Timezone', value: 'Local Timezone' },
                                { label: 'UTC Timezone', value: 'UTC Timezone' }
                                ]}
                                        onChange={(e)=>{changeTimezone(e)}}
                                        size='regular'
                                    defaultValue="Local Timezone"
                                    optionType="button"
                                    buttonStyle="solid"
                                    />
                                </div>

                                </div>
                                
                                <div className={`${styles['filter-element']}`}>
                                    <Button icon={<DownloadOutlined />} onClick={()=>{getStateLevelDataReport()}} className={styles['flex-item']} loading={isLoading.getActiveStatesDataReportLoading} disabled={(filterFromDate === null) || (filterToDate === null) } type="primary">Download</Button>
                                </div>
                            
                            </div>
                            
                        </div>

                    </Panel>
                </Collapse>
            </div>




        </Container>
    );

};

Reports.propTypes = {
    user: PropTypes.string,
    type: PropTypes.string
};
const ReportProps = (state) => ({
    user: state.auth && state.auth.user ? state.auth.user.firstName : null,
    type: state.auth && state.auth.user ? state.auth.user.type : null
});
export default connect(ReportProps, {})(Reports);
